import React from "react";

const Features = () => {
  return (
    <section id="features" className="container px-8 py-16 mx-auto">
      <h2 className="text-3xl font-bold text-center text-gray-900">Key Features of EzzyDental</h2>
      <p className="mt-4 text-lg text-center text-gray-700">
        VYX Dental provides industry-leading features to streamline your practice management.
      </p>
      <div className="grid gap-8 mt-8 md:grid-cols-3">
        <div className="p-6 bg-white rounded-lg shadow-lg">
          <h3 className="text-xl font-bold text-indigo-600">Cloud-Based Access</h3>
          <p className="mt-2 text-gray-700">Access patient data securely from anywhere, anytime.</p>
        </div>
        <div className="p-6 bg-white rounded-lg shadow-lg">
          <h3 className="text-xl font-bold text-indigo-600">Automated Scheduling</h3>
          <p className="mt-2 text-gray-700">Easily manage appointments with smart scheduling tools.</p>
        </div>
        <div className="p-6 bg-white rounded-lg shadow-lg">
          <h3 className="text-xl font-bold text-indigo-600">HIPAA Compliance</h3>
          <p className="mt-2 text-gray-700">Ensure data security and compliance with industry standards.</p>
        </div>
      </div>
    </section>
  );
};

export default Features;
